import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICuriosity } from '../models/curiosity';
import { PageEndpoint } from '../endpoints/page';
import { StringUtil } from '@shared/utils';

/**
 * ### **CuriosityService**
 *
 * Un Servicio en Angular es el mecanismo para compartir funcionalidad entre componentes, en este caso se encarga de compartir las funciones
 * para las curiosidades, estas hacen diferentes peticiones o llamados a distintos API's que genera el backend.
 */
@Injectable({
  providedIn: 'root',
})
export class Curiosity {
  private readonly http = inject(HttpClient);

  /** @ignore*/
  constructor() {}

  /**
   * Función encargado de obtener una curiosidad en específico.
   * @param id recibe el identificador númerico de la curiosidad.
   */
  get(id: number): Observable<ICuriosity> {
    return this.http.get<ICuriosity>(StringUtil.format(PageEndpoint.curiosity, id));
  }

  /**
   * Función encargada de obtener la primera curiosidad de la lista de curiosidades.
   */
  first(): Observable<ICuriosity> {
    return this.http.get<ICuriosity>(PageEndpoint.firstCuriosity);
  }

  /**
   * Función encargada de obtener la lista de curiosidades.
   */
  list(): Observable<Array<ICuriosity>> {
    return this.http.get<Array<ICuriosity>>(PageEndpoint.curiosities);
  }
}
